function FundingFeePair(){
    return <>
        <div>
        FundingFeePair
        </div>
    </>;
}

export default FundingFeePair;